"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAemLayoutController = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
const aem_layout_controller_1 = require("./aem-layout-controller");
function useAemLayoutController() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const aemLayoutController = (0, vue_1.inject)(injection_symbols_1.aemLayoutControllerKey);
    const aemLayoutLocalController = (0, aem_layout_controller_1.createAemLayoutLocalController)({
        aemLayoutController
    });
    return aemLayoutLocalController;
}
exports.useAemLayoutController = useAemLayoutController;
//# sourceMappingURL=use-api.js.map